import { Dayjs } from 'dayjs';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import { PickersShortcutsProps } from '@mui/x-date-pickers/PickersShortcuts';
import { DateRange } from '@mui/x-date-pickers-pro/models';
import { useIsValidValue, usePickerContext } from '@mui/x-date-pickers/hooks';
import { colors } from '../../../../styles/color-tokens';
import 'dayjs/locale/nb';

export function RangeShortcuts(props: PickersShortcutsProps<DateRange<Dayjs>>) {
  const { items, changeImportance = 'accept' } = props;
  const isValid = useIsValidValue<DateRange<Dayjs>>();
  const { setValue } = usePickerContext<DateRange<Dayjs>>();

  if (items == null || items.length === 0) {
    return null;
  }

  const resolvedItems = items.map((item) => {
    const newValue = item.getValue({ isValid });

    return {
      label: item.label,
      onClick: () => {
        setValue(newValue, { changeImportance, shortcut: item });
      },
      disabled: !isValid(newValue),
    };
  });

  return (
    <Box
      className="flex flex-col"
      sx={{
        backgroundColor: colors.background.surface.base,
        gridRow: 1,
        gridColumn: '2 / 4',
      }}
    >
      <div className="flex flex-row gap-2 self-center flex-wrap min-w-xs max-w-xl py-6 px-2 justify-around items-center">
        {resolvedItems.map((item) => {
          return (
            <Chip
              key={item.label}
              {...item}
              sx={{
                backgroundColor: colors.background.surface.elevated,
                color: colors.text.primary,
                '&:hover': { backgroundColor: colors.background.surface.hover },
              }}
            />
          );
        })}
      </div>
      <Divider color={colors.border.default} />
    </Box>
  );
}
